export default class CoachMark {
  constructor({element: element}) {
    this.$element = $(element);
    this.cookieName = this.$element.data("cookie-name");
    this.$element.find(".coach-mark__button-close").on("click", () => this.close());
  }

  close() {
    if(this.cookieName !== undefined) {
      this.setCookie(this.cookieName);
    }
    this.$element.find(".coach-mark__arrow").css("display", "none");
    this.$element.find(".coach-mark__content").css("display", "none");
  }

  setCookie(cookieName) {
    $.cookie(cookieName, 'true', { expires: 30 });
  }
}
